import script from "./new-edit-email-signatures-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-email-signatures-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-edit-email-signatures-modal.vue?vue&type=style&index=0&id=824e420c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824e420c"]])

export default __exports__